import { IStyle, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { BwjPalette } from '../../app-core/app-theme';

// NOTE: The size of this component can be controlled by its container's font size.  It has a height of 5em 
interface IAppLogoProps {
  business: string;
  href?: string;
}

const getStyleClasses = () => {
  const logo: IStyle = {
    display: 'flex',
    position: 'relative',
    margin: 0,
    padding: 0,
    textDecoration: 'none',
    fontWeight: 700,
    gap: '1em',
    alignItems: 'center',
    color: BwjPalette.themeGrey,

    '& > img': {
      display: 'block',
      border: 'none',
      margin: 0,
      padding: 0,
      height: '5em',
    },
    '& > span': {
      display: 'block',
      fontSize: '4em',
    }
  };

  return mergeStyleSets({
    logo,
  });
}

const AppLogoContent: React.FunctionComponent<IAppLogoProps> = (props) => {
  return (
    <>
      <img alt={`BWJ ${props.business} logo`} src="//bwjstorm.com/images/logo.png" />
      <span>{props.business}</span>
    </>
  );
};

export const AppLogo: React.FunctionComponent<IAppLogoProps> = (props) => {
  const classes = getStyleClasses();

  return (
    <>
      {!!props.href ?
      <a className={classes.logo} href={props.href} title={`BWJ ${props.business} Home`}>
        <AppLogoContent {...props} />
      </a>
      :
      <div className={classes.logo}>
        <AppLogoContent {...props} />
      </div>}
    </>
  );
};
